import { useMemo } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { suitesProjectsTranslator } from '../translations/suitesProjects';
import { toast } from '../hooks/use-toast';

export default function useSuitesProjectsLanguage() {
  const { language } = useLanguage();
  const t = useMemo(() => suitesProjectsTranslator(language), [language]);
  const notify = (message, type) => toast({
    title: language === 'es'
      ? { success: 'Éxito', error: 'Error', warning: 'Advertencia' }[type]
      : { success: 'Success', error: 'Error', warning: 'Warning' }[type],
    description: t(message), duration: 5000,
    ...(type === 'error' ? { variant: 'destructive' } : {}),
  });
  return { language, t, showSuccess: (m) => notify(m, 'success'),
    showError: (m) => notify(m, 'error'), showWarning: (m) => notify(m, 'warning') };
}
